import BaseIcon from "./BaseIcon.jsx";

const colorMap = {
  white:   "bg-white text-gray-800 border-gray-200 hover:bg-gray-50 dark:bg-slate-700 dark:text-white dark:border-slate-600 dark:hover:bg-slate-600",
  light:   "bg-gray-100 text-gray-700 border-gray-100 hover:bg-gray-200 dark:bg-slate-700 dark:text-white dark:border-slate-600",
  contrast:"bg-gray-800 text-white border-gray-800 hover:bg-gray-700 dark:bg-white dark:text-gray-800 dark:border-white",
  success: "bg-emerald-500 text-white border-emerald-500 hover:bg-emerald-600",
  danger:  "bg-red-500 text-white border-red-500 hover:bg-red-600",
  warning: "bg-amber-500 text-white border-amber-500 hover:bg-amber-600",
  info:    "bg-blue-500 text-white border-blue-500 hover:bg-blue-600",
  "success-outline": "text-emerald-600 border-emerald-500 hover:bg-emerald-50 dark:text-emerald-400 dark:hover:bg-emerald-900/30",
  "danger-outline":  "text-red-600 border-red-500 hover:bg-red-50 dark:text-red-400 dark:hover:bg-red-900/30",
  "info-outline":    "text-blue-600 border-blue-500 hover:bg-blue-50 dark:text-blue-400 dark:hover:bg-blue-900/30",
  "white-outline":   "text-gray-700 border-gray-300 hover:bg-gray-100 dark:text-white dark:border-slate-600 dark:hover:bg-slate-700",
};

export default function BaseButton({
  label,
  icon,
  iconRight,
  color = "white",
  outline = false,
  small = false,
  disabled = false,
  roundedFull = false,
  className = "",
  href,
  target,
  onClick,
  type = "button",
  loading = false,
}) {
  const colorKey = outline ? `${color}-outline` : color;
  const colorClass = colorMap[colorKey] || colorMap.white;
  const sizeClass = small ? "py-1 px-2 text-xs" : "py-2 px-3 text-sm";
  const radiusClass = roundedFull ? "rounded-full" : "rounded-lg";

  const inner = (
    <>
      {loading && (
        <span className="mr-1 inline-block h-3.5 w-3.5 animate-spin rounded-full border-2 border-current border-t-transparent opacity-70" />
      )}
      {!loading && icon && <BaseIcon path={icon} size={small ? 14 : 16} />}
      {label && (
        <span className={icon && !iconRight ? "ml-1.5" : iconRight ? "mr-1.5" : ""}>
          {label}
        </span>
      )}
      {iconRight && <BaseIcon path={iconRight} size={small ? 14 : 16} />}
    </>
  );

  const baseClass = [
    "inline-flex items-center justify-center whitespace-nowrap",
    "border font-medium leading-tight cursor-pointer",
    "transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-1",
    "disabled:opacity-50 disabled:cursor-not-allowed",
    colorClass, sizeClass, radiusClass, className,
  ].join(" ");

  if (href) {
    return (
      <a href={href} target={target} className={baseClass} aria-disabled={disabled}>
        {inner}
      </a>
    );
  }

  return (
    <button type={type} className={baseClass} disabled={disabled || loading} onClick={onClick}>
      {inner}
    </button>
  );
}
